module.exports = __webpack_public_path__ + "img/951-v.812282b7.jpg";